import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class PetsService {
  public petListany: any = [];
public currentUser :any;
  constructor(
    private http: HttpClient,
    public translate: TranslateService
  ) {
  }

  private specieVal = new BehaviorSubject('');
  specValue = this.specieVal.asObservable();

  changeSpecie = (val) => {
    this.specieVal.next(val);
  }

  private loginPopup = new BehaviorSubject(false);
  openLoginPopup = this.loginPopup.asObservable();

  openLogin = (queryParams) => {
    this.loginPopup.next(queryParams);
  }

  getCountry() {
    const HttpUploadOptions = {
      headers: new HttpHeaders(
        {
          'Authorization': 'Basic ' + btoa('36CD6FB6-A785-4EFF-ACDB-5B1609B914B2:45@#cvd67@NM')
        })
    }
    return this.http.get<any>(`${environment.apiUrl + environment.getCountryDropdown}`,HttpUploadOptions);
  }

  getSpecies() {
    const HttpUploadOptions = {
      headers: new HttpHeaders(
        {
          'Authorization': 'Basic ' + btoa('36CD6FB6-A785-4EFF-ACDB-5B1609B914B2:45@#cvd67@NM')
        })
    }
    let browserLang = this.translate.getBrowserLang();
    let LanguageCode = browserLang.match(/en|no/) ? browserLang : 'no';
    return this.http.get<any>(`${environment.apiUrl + environment.getSpeciesDropDown}?LanguageCode=${LanguageCode}`,HttpUploadOptions);
  }

  getBreeds(species: string) {
    const HttpUploadOptions = {
      headers: new HttpHeaders(
        {
          'Authorization': 'Basic ' + btoa('36CD6FB6-A785-4EFF-ACDB-5B1609B914B2:45@#cvd67@NM')
        })
    }
    let browserLang = this.translate.getBrowserLang();
    let LanguageCode = browserLang.match(/en|no/) ? browserLang : 'no';
    let breedURL = `${environment.apiUrl + environment.getBreedsDropDown}?SpeciesID=${species}&GetActive=true&LanguageCode=${LanguageCode}`;
    return this.http.get<any>(breedURL,HttpUploadOptions);
  }

  getChipInfo(chipId: string) {
    const HttpUploadOptions = {
      headers: new HttpHeaders(
        {
          'Authorization': 'Basic ' + btoa('36CD6FB6-A785-4EFF-ACDB-5B1609B914B2:45@#cvd67@NM')
        })
    }
    let chipInfo = `${environment.GetChipInfo}?chipId=${chipId}`;
    return this.http.get<any>(chipInfo,HttpUploadOptions);
  }

  IsChipIDExists(chipId: string, OperationTypeID: any) {
    const HttpUploadOptions = {
      headers: new HttpHeaders(
        {
          'Authorization': 'Basic ' + btoa('36CD6FB6-A785-4EFF-ACDB-5B1609B914B2:45@#cvd67@NM')
        })
    }
    let IsChipID = `${environment.apiUrl + environment.IsChipIDExists}?chipId=${chipId}&OperationTypeID=${OperationTypeID}`;
    return this.http.get<any>(IsChipID,HttpUploadOptions);
  }

  GetLostFoundPetsListPartialFields(filter: any) {
    const HttpUploadOptions = {
      headers: new HttpHeaders(
        {
          'Authorization': 'Basic ' + btoa('36CD6FB6-A785-4EFF-ACDB-5B1609B914B2:45@#cvd67@NM')
        }),
        params:filter
    }
    let URL = `${environment.apiUrl + environment.GetLostFoundPetsListPartialFields}`;
    return this.http.get(URL, HttpUploadOptions);
    // return this.http.get<any>(URL,{params: filter});
  }
  GetLostFoundPetsListfromMincide(filter: any) {
    let URL = `${environment.apiUrlMinside + environment.GetLostFoundPetsList}`;
    return this.http.get(URL, { params: filter });
    // return this.http.get<any>(URL,{params: filter});
  }

  GetPetsForLandingPage(filter: any) {
    const HttpUploadOptions = {
      headers: new HttpHeaders(
        {
          'Authorization': 'Basic ' + btoa('36CD6FB6-A785-4EFF-ACDB-5B1609B914B2:45@#cvd67@NM')
        }),
        params:filter
    }
    let URL = `${environment.apiUrl + environment.GetPetsForLandingPage}`;
    return this.http.get(URL, HttpUploadOptions);

  }
  GetPetsForLandingPage1() {
    const HttpUploadOptions = {
      headers: new HttpHeaders(
        {
          'Authorization': 'Basic ' + btoa('36CD6FB6-A785-4EFF-ACDB-5B1609B914B2:45@#cvd67@NM')
        })
    }
    let URL = `${environment.apiUrl + environment.GetPetsForLandingPage}`;
    return this.http.get(URL,HttpUploadOptions);
  }
  GetLandingPageLostPets(filter: any) {
    const HttpUploadOptions = {
      headers: new HttpHeaders(
        {
          'Authorization': 'Basic ' + btoa('36CD6FB6-A785-4EFF-ACDB-5B1609B914B2:45@#cvd67@NM')
        }),
        params:filter
    }
    let URL = `${environment.apiUrl + environment.GetLandingPageLostPets}`;
    return this.http.get<any>(URL, HttpUploadOptions);
  }

  GetLandingPageFoundPets(filter: any) {
    const HttpUploadOptions = {
      headers: new HttpHeaders(
        {
          'Authorization': 'Basic ' + btoa('36CD6FB6-A785-4EFF-ACDB-5B1609B914B2:45@#cvd67@NM')
        }),
        params:filter
    }
    let URL = `${environment.apiUrl + environment.GetLandingPageFoundPets}`;
    return this.http.get(URL, HttpUploadOptions);
  }

  GetLandingPageLostPets_(filter: any) {
    const HttpUploadOptions = {
      headers: new HttpHeaders(
        {
          'Authorization': 'Basic ' + btoa('36CD6FB6-A785-4EFF-ACDB-5B1609B914B2:45@#cvd67@NM')
        }),
        params:filter
    }
    let URL = `${environment.apiUrl + environment.GetLandingPageLostPets}`;
    return this.http.get(URL, HttpUploadOptions);
  }

  GetLostPetsForLandingPage() {
    const HttpUploadOptions = {
      headers: new HttpHeaders(
        {
          'Authorization': 'Basic ' + btoa('36CD6FB6-A785-4EFF-ACDB-5B1609B914B2:45@#cvd67@NM')
        })
    }
    let URL = `${environment.apiUrl + environment.GetLostPetsForLandingPage}`;
    return this.http.get(URL,HttpUploadOptions);

  }

  GetFoundPetsForLandingPage() {
    const HttpUploadOptions = {
      headers: new HttpHeaders(
        {
          'Authorization': 'Basic ' + btoa('36CD6FB6-A785-4EFF-ACDB-5B1609B914B2:45@#cvd67@NM')
        })
    }
    let URL = `${environment.apiUrl + environment.GetFoundPetsForLandingPage}`;
    return this.http.get(URL,HttpUploadOptions);

  }
  GetAllPetsForLandingPage() {
    const HttpUploadOptions = {
      headers: new HttpHeaders(
        {
          'Authorization': 'Basic ' + btoa('36CD6FB6-A785-4EFF-ACDB-5B1609B914B2:45@#cvd67@NM')
        })
    }
    let URL = `${environment.apiUrl + environment.GetAllPetsForLandingPage}`;
    return this.http.get(URL,HttpUploadOptions);

  }


  addUpdateLostFoundPetDetails(petdata) {  
    debugger;
    //var Authorization = $.cookie("Authorization")  
    const _name = 'Authorization';
    let Authorization1 = "";
    let Authorization = `; ${document.cookie}`.match(`;\\s*${_name}=([^;]+)`);
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${_name}=`);
  if (parts.length === 2) { Authorization1 =  parts.pop().split(';').shift();}
  this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
      if(Authorization1 == null || Authorization1 == ""){
        Authorization1 = localStorage.getItem('Authorization');
      }

    const HttpUploadOptions = {
      headers: new HttpHeaders(
        {
          //"Content-Type": "application/x-www-form-urlencoded",
          "APIKEY": "560C51EE-D641-487E-AD6F-1C2A525C2727",
          "Authorization": Authorization1,
          "EmailId":this.currentUser.EmailID
        })
    }
    return this.http.post(`${environment.apiUrl + environment.AddUpdateLostFoundPetDetails}`, petdata, HttpUploadOptions);
  }
  googlevision(imageBase64:any,searchType:any) {
    const body = {
      "requests":[
        {
          "image":{
            "content":imageBase64
          },
          "features":[
            {
              "type":searchType,
              "maxResults":100
            }
          ]
        }
      ]
    }
    let URL = `${environment.GoogleVisionAI}`;
    return this.http.post(URL, body);
  }
  GetLostFoundPetsList(filter: any) {    
    const HttpUploadOptions = {
      headers: new HttpHeaders(
        {
          'Authorization': 'Basic ' + btoa('36CD6FB6-A785-4EFF-ACDB-5B1609B914B2:45@#cvd67@NM')
        }),
        params:filter
    }
    let URL = `${environment.apiUrl + environment.GetLostFoundNeighbourPetListWithFilter}`;
    return this.http.get<any>(URL, HttpUploadOptions);
  }

  GetLostFoundPetsListForHomePage(filter: any) {
    const HttpUploadOptions = {
      headers: new HttpHeaders(
        {
          'Authorization': 'Basic ' + btoa('36CD6FB6-A785-4EFF-ACDB-5B1609B914B2:45@#cvd67@NM')
        }),
        params:filter
    }
    let URL = `${environment.apiUrl + environment.GetLostFoundPetsListForHomePage}`;
    return this.http.get<any>(URL, HttpUploadOptions);
  }

  // GetReportedPetsCount(filter: any)
  // {
  //   let URL = `${environment.apiUrl + environment.GetReportedPetsCount }`;
  //   return this.http.get<any>(URL,{params: filter});
  // }

  // GetReportedPetsCountMap(filter: any)
  // {
  //   let URL = `${environment.apiUrl + environment.GetReportedPetsCountMap }`;
  //   return this.http.get<any>(URL,{params: filter})
  // }

  GetLostFoundPetDetailsByID(parameters) {
    const HttpUploadOptions = {
      headers: new HttpHeaders(
        {
          'Authorization': 'Basic ' + btoa('36CD6FB6-A785-4EFF-ACDB-5B1609B914B2:45@#cvd67@NM')
        }),
        params:parameters
    }
    if (parameters != null && parameters != undefined) {
      return this.http.get<any>(`${environment.apiUrl + environment.GetLostFoundPetDetailsByID}`, HttpUploadOptions);
    }
    else
      return null;
  }

  GetLostFoundPetsListByUser(filter: any) {
    const _name = 'Authorization';
    let Authorization1 = "";
    let Authorization = `; ${document.cookie}`.match(`;\\s*${_name}=([^;]+)`);
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${_name}=`);
  if (parts.length === 2) { Authorization1 =  parts.pop().split(';').shift();}
  this.currentUser = JSON.parse(localStorage.getItem('currentUser'));

  if(Authorization1 == null || Authorization1 == ""){
    Authorization1 = localStorage.getItem('Authorization');
  }
    const HttpUploadOptions = {
      headers: new HttpHeaders(
        {
          "Authorization": Authorization1,
          "EmailId":this.currentUser.EmailID
        })
    }
    let URL = `${environment.apiUrl + environment.GetLostFoundPetsListByUser}`;
    return this.http.post<any>(URL, filter,HttpUploadOptions);
  }
  GetLostFoundPetsListCountByUser(filter: any) {
    const _name = 'Authorization';
    let Authorization1 = "";
    let Authorization = `; ${document.cookie}`.match(`;\\s*${_name}=([^;]+)`);
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${_name}=`);
  if (parts.length === 2) { Authorization1 =  parts.pop().split(';').shift();}
  this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
  if(Authorization1 == null || Authorization1 == ""){
    Authorization1 = localStorage.getItem('Authorization');
  }
    const HttpUploadOptions = {
      headers: new HttpHeaders(
        {
          "Authorization": Authorization1,
          "EmailId":this.currentUser.EmailID
        })
    }
    let URL = `${environment.apiUrl + environment.GetLostFoundPetsListCountByUser}`;
    return this.http.post<any>(URL, filter,HttpUploadOptions);
  }

  markPetAsReunited(postData: any) {
    const _name = 'Authorization';
    let Authorization1 = "";
    let Authorization = `; ${document.cookie}`.match(`;\\s*${_name}=([^;]+)`);
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${_name}=`);
  if (parts.length === 2) { Authorization1 =  parts.pop().split(';').shift();}
  this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
  if(Authorization1 == null || Authorization1 == ""){
    Authorization1 = localStorage.getItem('Authorization');
  }
    const HttpUploadOptions = {
      headers: new HttpHeaders(
        {
          "Authorization": Authorization1,
          "EmailId":this.currentUser.EmailID
        })
    }
    let URL = `${environment.apiUrl + environment.MarkPetasReunited}`;
    return this.http.post<any>(URL, postData,HttpUploadOptions);
  }
  GetPetSuggestion(postData: any) {
    const HttpUploadOptions = {
      headers: new HttpHeaders(
        {
          'Authorization': 'Basic ' + btoa('36CD6FB6-A785-4EFF-ACDB-5B1609B914B2:45@#cvd67@NM')
        })
    }

    let URL = `${environment.apiUrl + environment.GetPetSuggestionbyLostFoundId}`;
    return this.http.post<any>(URL, postData,HttpUploadOptions);
  }
  RemoveReportedPet(postData: { LostFoundId: any; UpdatedBy: any; }) {
    const _name = 'Authorization';
    let Authorization1 = "";
    let Authorization = `; ${document.cookie}`.match(`;\\s*${_name}=([^;]+)`);
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${_name}=`);
  if (parts.length === 2) { Authorization1 =  parts.pop().split(';').shift();}
  this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
  if(Authorization1 == null || Authorization1 == ""){
    Authorization1 = localStorage.getItem('Authorization');
  }
    const HttpUploadOptions = {
      headers: new HttpHeaders(
        {
          "Authorization": Authorization1,
          "EmailId":this.currentUser.EmailID
        })
    }
    let URL = `${environment.apiUrl + environment.RemoveReportedPet}`;
    return this.http.post<any>(URL, postData,HttpUploadOptions);
  }

  UpdatePetInfo(petInfo) {
    const _name = 'Authorization';
    let Authorization1 = "";
    let Authorization = `; ${document.cookie}`.match(`;\\s*${_name}=([^;]+)`);
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${_name}=`);
  if (parts.length === 2) { Authorization1 =  parts.pop().split(';').shift();}
  this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
  if(Authorization1 == null || Authorization1 == ""){
    Authorization1 = localStorage.getItem('Authorization');
  }
    const HttpUploadOptions = {
      headers: new HttpHeaders(
        {
          "Authorization": Authorization1,
          "EmailId":this.currentUser.EmailID
        })
    }
    return this.http.post(`${environment.apiUrl + environment.UpdatePetInfo}`, petInfo,HttpUploadOptions);
  }
  checkFacebookPost(lostFoundID:any) {
    const _name = 'Authorization';
    let Authorization1 = "";
    let Authorization = `; ${document.cookie}`.match(`;\\s*${_name}=([^;]+)`);
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${_name}=`);
  if (parts.length === 2) { Authorization1 =  parts.pop().split(';').shift();}
  this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
  if(Authorization1 == null || Authorization1 == ""){
    Authorization1 = localStorage.getItem('Authorization');
  }
    const HttpUploadOptions = {
      headers: new HttpHeaders(
        {
          "Authorization": Authorization1,
          "EmailId":this.currentUser.EmailID
        })
    }
    return this.http.get(`${environment.apiUrl + environment.CheckFacebookPost}` + '?lostFoundID=' + lostFoundID,HttpUploadOptions);
  }
  checkFacebookAccount(lostFoundID:any) {
    const _name = 'Authorization';
    let Authorization1 = "";
    let Authorization = `; ${document.cookie}`.match(`;\\s*${_name}=([^;]+)`);
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${_name}=`);
  if (parts.length === 2) { Authorization1 =  parts.pop().split(';').shift();}
  this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
  if(Authorization1 == null || Authorization1 == ""){
    Authorization1 = localStorage.getItem('Authorization');
  }
    const HttpUploadOptions = {
      headers: new HttpHeaders(
        {
          "Authorization": Authorization1,
          "EmailId":this.currentUser.EmailID
        })
    }
    return this.http.get(`${environment.apiUrl + environment.CheckFacebookAccount}` + '?lostFoundID=' + lostFoundID,HttpUploadOptions);
  }
  assignListData(petList: any): void {
    this.petListany = [...petList];
  }
  UpdatePetImage(petInfo) {
    const HttpUploadOptions = {
      headers: new HttpHeaders(
        {
          'Authorization': 'Basic ' + btoa('36CD6FB6-A785-4EFF-ACDB-5B1609B914B2:45@#cvd67@NM')
        })
    }
    return this.http.post(`${environment.apiUrl + environment.UpdatePetImage}`, petInfo,HttpUploadOptions);
  }
  fetchListData(): any {
    return this.petListany;
  }
  addContactOwnerInformation(contactInfo: any) {
    const HttpUploadOptions = {
      headers: new HttpHeaders(
        {
          'Authorization': 'Basic ' + btoa('36CD6FB6-A785-4EFF-ACDB-5B1609B914B2:45@#cvd67@NM')
        })
    }
    let URL = `${environment.apiUrl + environment.AddContactOwnerInformation}`;
    return this.http.post<any>(URL, contactInfo,HttpUploadOptions);
  }

  getZipCodeCity(zipCode: string) {
    const headers = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "APIKEY": "34A4601F-0930-4A22-8993-97B951881F83",
        "Password": "xxxaeexrkp",
        "DeviceType": "website",
        "DeviceToken": "website",
        "DeviceId": "website"
      })
    }
    let zipCodeCity = `${environment.GetZipCodeCity}?ZipCode=${zipCode}`;
    return this.http.get<any>(zipCodeCity, headers);
  }

  updatePetReminderDetail(lostfoundId: number) {
    const HttpUploadOptions = {
      headers: new HttpHeaders(
        {
          'Authorization': 'Basic ' + btoa('36CD6FB6-A785-4EFF-ACDB-5B1609B914B2:45@#cvd67@NM')
        })
    }
    let updateReminderDetailURL = `${environment.apiUrl + environment.UpdatePetReminderDetail}`;
    let request = {
      'LostFoundId': lostfoundId
    }
    return this.http.post<any>(updateReminderDetailURL, request,HttpUploadOptions);
  }
}